<template>

  <div class="sidebar-group">
    <div class="title">
      {{title}}
    </div>
    <div class="list">
      <router-link
        :to="item.route && item.route.name ? {name: item.route.name} : '/'"
        :class="[
          'item',
          {
            'is-preparing': item.isPreparing
          }
        ]"
        v-for="item in items"
        v-on:click="$store.commit('toggleSidebar', false)"
        :key="item.name"
      >
        <div class="item-text">
          {{item.title}}
        </div>
        <div class="item-preparing-pill" v-if="item.isPreparing">
          preparing
        </div>
        <div class="item-new-pill" v-if="item.isNew">
          NEW
        </div>
      </router-link>
    </div>
  </div>

</template>

<script>

export default {
  props: {
    title: String,
    items: Array
  }
}

</script>

<style lang="scss" scoped>
.sidebar-group {
  margin-top: 50px;
  @media screen and (max-width: 768px) {
    margin: 0 0 32px;
    &:last-child {
      margin: 0;
    }
  }
  @media screen and (max-width: 540px) {
    margin: 0 0 40px;
    &:last-child {
      margin: 0;
    }
  }
}

.title {
  font-size: var(--typ-body3);
  font-weight: 700;
  color: var(--gray-500);
  padding: 0 14px 14px;
  border-bottom: 1px solid var(--gray-300);
  margin: 0 0 8px;
  user-select: none;
  @media screen and (max-width: 768px) {
    font-size: var(--typ-body5);
    padding: 0 14px 10px;
  }
}

.item {
  height: 56px;
  border-radius: 8px;
  font-size: var(--typ-h5);
  color: var(--gray-900);
  font-weight: 700;
  display: flex;
  align-items: center;
  padding: 0 0 0 14px;
  user-select: none;
  text-decoration: none;

  @media screen and (max-width: 768px) {
    height: 48px;
    font-size: var(--type-body2);
  }
  @media screen and (max-width: 540px) {
    height: 40px;
    font-size: var(--typ-body5);
  }

  &:not(.is-preparing):hover {
    background-color: var(--gray-200);
  }
  &:not(.is-preparing):active {
    background-color: var(--gray-300);
  }

  &.is-preparing {
    pointer-events: none;
    color: var(--gray-500);
  }
}

.item-text {
  user-select: none;
}

.item-preparing-pill {
  height: 20px;
  padding: 0 8px;
  line-height: 18px;
  font-size: 12px;
  border: 1px solid var(--gray-400);
  border-radius: 16px;
  font-weight: 400;
  color: var(--gray-700);
  margin-left: 10px;
}

.item-new-pill {
  font-size: 12px;
  font-weight: 400;
  display: flex;
  align-items: center;
  color: var(--info-500);
  border: 1px solid var(--info-500);
  padding: 0 8px;
  height: 20px;
  margin-left: 10px;
  border-radius: 50px;
}
</style>